import React from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Snackbar from "@material-ui/core/Snackbar";
//import SnackbarContent from '@material-ui/core/SnackbarContent';
//import IconButton from "@material-ui/core/IconButton";
//import Icon from "@material-ui/core/Icon";
//import CheckCircleIcon from '@material-ui/icons/CheckCircle';
//import CloseIcon from '@material-ui/icons/Close';
//import {red, green} from '@material-ui/core/colors';
//import InfoIcon from '@material-ui/icons/Info';
//import ErrorIcon from '@material-ui/icons/Error';
//import WarningIcon from '@material-ui/icons/Warning';
import MuiAlert from '@material-ui/lab/Alert';
//import Spinner from 'react-bootstrap/Spinner';
//import { makeStyles } from '@material-ui/core/styles';

import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function DisplaySnackbar(props) {

    function handleClose(){
        props.onClearSnackbar();
    }

    //let color = (props.snackbarType === actionTypes.SNACKBAR_TYPE_ERROR)?red[500]:green[500];
    //let iconType = (props.snackbarType === actionTypes.SNACKBAR_TYPE_ERROR)?<ErrorIcon style={{marginRight: '5px'}}/>:<CheckCircleIcon style={{marginRight: '5px'}}/>;
    let severity = (props.snackbarType === actionTypes.SNACKBAR_TYPE_ERROR)?"error":"success";

    return (

        <Snackbar
            open={props.isSnackbarOpen}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
        >
            <Alert onClose={handleClose} severity={severity}>
                {props.snackbarMessage}
            </Alert>
        </Snackbar>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onClearSnackbar: () => dispatch(actions.clearSnackbar())
    }
};

const mapStateToProps = state => {
    return {
        isSnackbarOpen: state.snackbar.successSnackbarOpen,
        snackbarMessage: state.snackbar.successSnackbarMessage,
        snackbarType: state.snackbar.snackbarType
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySnackbar);